import {Injectable} from "@angular/core";
import {LogManager} from '../log/log.manager';
import {LogCat} from '../log/log.categories';
import {HttpObservable, HttpWrapper} from '../http-helpers/http.wrapper';

/**
 ****************************************************************
 * Proxy service class for asset calls.
 *
 * Created by Shai Zelman on 03/05/2020.
 ****************************************************************
 */
@Injectable({
	providedIn: "root"
})
export class AssetsProxy {
	constructor(private httpWrapper: HttpWrapper) {}

	public getStaticAssetByCode(code: string): HttpObservable<Blob> {
		LogManager.debug(LogCat.Asset.Proxy, "Get static asset by code.", code);

		return this.httpWrapper.getBlob("StaticAsset", "GetStaticAssetByCode", { pName: "code", pVal: code }, null, true, true);
	}
}
